import { api } from './client';
import type { EmployeePromptApp, EmployeePromptListResponse } from '@shared/types';

export const employeePromptsApi = {
  listMine: async (app: EmployeePromptApp = 'mobile'): Promise<EmployeePromptListResponse> => {
    const { data } = await api.get('/employee-prompts/me', { params: { app } });
    return data;
  },
};
